import React from 'react';
import '../ModulePage/Modals/Modals.scss';

const WhatsNewModal = ({ message, onClose }) => (
  <div className='cb-modal' id={'whatsnew'} aria-hidden='false' data-cb-apricot='modal' style={{display:'block'}}>
  <div className='cb-modal-overlay' tabIndex='-1'>
    <div className='cb-modal-container' role='dialog' aria-modal='true' aria-labelledby={`whatsnew_Title`} aria-describedby={`dialogueDsc_whatsnew`}>
    <div className='cb-modal-header'>
            <div id={`whatsnew_Title`} className='display-flex justify-content-start align-items-center headerStyle' style={{width: '100%'}}>
              <span style={{marginRight: '5px'}} className='cb-icon cb-icon-circular cb-icon-14 cb-megaphone'></span>
              <span style={{width:'100%', display: 'flex', flexWrap:'wrap'}}>Latest Updates & Announcements</span>
            </div>
    </div>

    <div className='cb-modal-content' id={`dialogueDsc_whatsnew`} dangerouslySetInnerHTML={{__html:message}}>
    </div>

    <button type='button' onClick={onClose} className='cb-btn cb-btn-primary' aria-describedby={`whatsnew_Title`} 
      style={{marginLeft:'80%'}}
      data-cb-modal-close>
          <span>Got it!</span>
    </button>

    </div>
  </div>
</div>
);
export default WhatsNewModal;